module.exports = __webpack_public_path__ + "img/flechas-recopila.58fa485f.png";